module.exports = __webpack_public_path__ + "assets/img/morenfile.6aee2ae2.svg";